import axios from "axios";
import { useState } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import { useCookies } from "react-cookie";

import { updateProductProgressPoint } from "components/UI/Functions/progressFunctions";
import { useAuth } from "hooks/useAuth";

const ValidatorKickoffModal = ({ show, onHide, product, refetch }) => {
  const [cookies] = useCookies();
  const [updatedData, setUpdatedData] = useState({});
  const { authToken, csrfToken, currentUser } = useAuth();

  const handleChange = (e) => {
    setUpdatedData({ ...updatedData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    const form = e.currentTarget;
    e.preventDefault();
    if (!form.checkValidity()) {
      e.stopPropagation();
    } else {
      await axios
        .put(
          `${import.meta.env.VITE_DJANGO_ENDPOINT}project/product/${product?.product_id}/`,
          {
            ...updatedData,
            kickoff_status: "Recommended for Kickoff",
            kickoff_recommended_by: currentUser.id,
            kickoff_recommended_date: new Date(
              new Date().setMinutes(
                new Date().getMinutes() - new Date().getTimezoneOffset(),
              ),
            ),
            rejected_rationale: null,
          },
          {
            withCredentials: true,
            headers: {
              "X-CSRFToken": csrfToken,
              Authorization: `Token ${authToken}`,
            },
          },
        )
        .then(async (response) => {
          await updateProductProgressPoint(
            response.data.product_id,
            2,
            "In Progress",
            cookies,
          );
          // The email + in-app alert are handled server-side by
          // project.notifications.notify_project_kickoff_recommendation,
          // fired from ProductViewSet.perform_update on the kickoff_status
          // transition driven by the product PUT above.
          refetch();
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  return (
    <Modal show={show} onHide={onHide}>
      <Form onSubmit={handleSubmit}>
        <Modal.Header closeButton>
          <h3 className="mb-0">Recommending for Kickoff</h3>
        </Modal.Header>
        <Modal.Body>
          {product?.rejected_rationale && (
            <div className="border-bottom mb-3">
              <h4 className="mt-2">Rejected Rationale:</h4>
              <p className="fw-bold">{product?.rejected_rationale}</p>
            </div>
          )}
          <Form.Group controlId="sync_radios">
            <Form.Label>Sync Required?</Form.Label>
            <Form.Check
              type="radio"
              name="sync_required"
              label="Yes"
              value={true}
              onChange={handleChange}
              id={"sync_required1"}
              required
            />
            <Form.Check
              type="radio"
              name="sync_required"
              label="No"
              value={false}
              onChange={handleChange}
              id={"sync_required2"}
              required
            />
          </Form.Group>
          {updatedData?.sync_required && (
            <Form.Group controlId="sync_justification">
              <Form.Label>Justification</Form.Label>
              <Form.Control
                as="textarea"
                name="sync_justification"
                onChange={handleChange}
                required={updatedData?.sync_required === "true"}
              />
            </Form.Group>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="outline-primary" type="clear" onClick={onHide}>
            Cancel
          </Button>
          <Button variant="success" type="submit" onClick={handleSubmit}>
            Recommend for Kickoff
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default ValidatorKickoffModal;
